import { Modal, Typography } from 'antd';
import { TFunction } from 'i18next';

import * as Styled from './fifo-confirmation-modal.style';

const { Text, Paragraph } = Typography;

interface ShowFifoConfirmationModalParams {
  t: TFunction;
  onConfirm: () => void;
  onCancel: () => void;
}

const showFifoConfirmationModal = ({
  t,
  onConfirm,
  onCancel,
}: ShowFifoConfirmationModalParams) => {
  const content = (
    <Styled.FifoModalContent>
      <Paragraph>{t('onboarding.start.fifoModal.subtitle')}</Paragraph>

      <Styled.FifoModalSection>
        <Text strong>{t('onboarding.start.fifoModal.section1.title')}</Text>
        <Paragraph>
          {t('onboarding.start.fifoModal.section1.description')}
        </Paragraph>
      </Styled.FifoModalSection>

      <Styled.FifoModalSection>
        <Text strong>{t('onboarding.start.fifoModal.section2.title')}</Text>
        <Paragraph>
          {t('onboarding.start.fifoModal.section2.description')}
        </Paragraph>
      </Styled.FifoModalSection>
    </Styled.FifoModalContent>
  );

  const modal = Modal.warning({
    title: t('onboarding.start.fifoModal.title'),
    content,
    width: 520,
    centered: true,
    onCancel: () => {
      onCancel();
      modal.destroy();
    },
  });

  modal.update({
    footer: (
      <Styled.FifoModalFooter>
        <Styled.FifoModalSecondaryButton
          onClick={() => {
            onCancel();
            modal.destroy();
          }}
        >
          {t('onboarding.start.fifoModal.cancelButton')}
        </Styled.FifoModalSecondaryButton>
        <Styled.FifoModalPrimaryButton
          onClick={() => {
            onConfirm();
            modal.destroy();
          }}
        >
          {t('onboarding.start.fifoModal.confirmButton')}
        </Styled.FifoModalPrimaryButton>
      </Styled.FifoModalFooter>
    ),
  });

  return modal.destroy;
};

export { showFifoConfirmationModal };
